import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Modal,
  IconButton,
  Divider,
  Grid,
  InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid } from "@mui/x-data-grid";
import { PAP_Brand_Search_GetrowApi } from "../../../Server/ApiV2";
import { fAlertToast } from "../../../Utility/Utilitys";

const BrandSearchModal = ({
  open = false,
  handleClose = () => {},
  onRowSelect = () => {},
  anyData = "",
  categoryCode,
  vMediaQuery,
  xTitle = "Brand Search",
}) => {
  const [searchData, setSearchData] = useState("");
  const [rows, setRows] = useState([]);
  const initialFetch = useRef(true);

  const columns = [
    { field: "id", headerName: "ID", hide: true },
    { field: "Code", headerName: "Brand Code", flex: 1.5 },
    { field: "Name", headerName: "Brand Name", flex: 3 },
  ];

  useEffect(() => {
    if (open) {
      setSearchData(anyData || "");
    } else {
      setSearchData("");
      setRows([]);
      initialFetch.current = true;
    }
  }, [open, anyData]);

  useEffect(() => {
    if (open && initialFetch.current && (anyData?.length ?? 0) >= 3) {
      fetchBrandData(anyData);
      initialFetch.current = false;
    }
  }, [open, anyData]);

  const fetchBrandData = async (query) => {
    const q = String(query ?? searchData ?? "").trim();

    if (q.length < 3) {
      fAlertToast("INFO", "Please enter at least 3 characters");
      setRows([]);
      return;
    }

    try {
      const payload = {
        anyData: q,
        Category: categoryCode,
      };

      const response = await PAP_Brand_Search_GetrowApi(payload);

      if (response?.status === 200) {
        const gridData =
          response?.data?.data?.Brand?.map((obj, i) => ({
            ...obj,
            id: i + 1,
          })) || [];

        setRows(gridData);
      } else {
        setRows([]);
      }
    } catch (err) {
      console.error("Brand search error:", err);
      setRows([]);
      fAlertToast("FAILED", "Brand search failed");
    }
  };

  const fCheckKey = (event) => {
    console.log(event.keyCode === 40, event.key);

    setTimeout(() => {
      if (event.keyCode === 40 && rows.length > 0) {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById("table-main-grid-4");
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            .firstChild?.focus();
        }
      }
    }, 100);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: vMediaQuery ? "95%" : 600,
          bgcolor: "#fff",
          borderRadius: 3,
          boxShadow: 6,
        }}
      >
        <Box className="modal-head">
          <Typography variant="h6" ml={1}>
            {xTitle}
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon sx={{ color: "#fff" }} />
          </IconButton>
        </Box>

        <Divider
          sx={{
            "&.MuiDivider-root": {
              borderColor: "#efeaea !important",
            },
          }}
        />

        <Grid container spacing={2} p={3} className="ItemRequest-filter">
          <Grid item xs={12}>
            <TextField
              fullWidth
              name="anyData"
              id="anyData"
              autoComplete="off"
              value={searchData}
              onChange={(e) => setSearchData(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fCheckKey(e);
                  fetchBrandData(e.target.value);
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon
                      sx={{ cursor: "pointer" }}
                      onClick={() => fetchBrandData(searchData)}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>

        <Box
          id="table-main-grid-4"
          sx={{ height: "50vh", width: "100%", px: 3, pb: 3 }}
        >
          <DataGrid
            rows={rows}
            columns={columns}
            rowHeight={32}
            headerHeight={40}
            hideFooter={(rows?.length ?? 0) < 100}
            onRowClick={(params) => {
              onRowSelect(params.row);
              handleClose();
            }}
            onCellKeyDown={(params, e) => {
              if (e.key === "Enter") {
                onRowSelect(params.row);
                handleClose();
              }
            }}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default BrandSearchModal;
